/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./__root"
import { Route as AppRouteImport } from "./_app"
import { Route as SignInRouteImport } from "./sign-in"
import { Route as AppIndexRouteImport } from "./_app.index"
import { Route as AppSettingsRouteImport } from "./_app.settings"

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof AppIndexRoute
  "/sign-in": typeof SignInRoute
  "/settings": typeof AppSettingsRoute
}
export interface FileRoutesByTo {
  "/sign-in": typeof SignInRoute
  "/settings": typeof AppSettingsRoute
  "/": typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/sign-in": typeof SignInRoute
  "/_app/settings": typeof AppSettingsRoute
  "/_app/": typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: "/" | "/sign-in" | "/settings"
  fileRoutesByTo: FileRoutesByTo
  to: "/sign-in" | "/settings" | "/"
  id: "__root__" | "/_app" | "/sign-in" | "/_app/settings" | "/_app/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sign-in": {
      id: "/sign-in"
      path: "/sign-in"
      fullPath: "/sign-in"
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings": {
      id: "/_app/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
